// extracted by mini-css-extract-plugin
export var isOpen = "BurgerMenu-module--isOpen--Zgc2g";
export var wrapper = "BurgerMenu-module--wrapper--bUPcg";